import $ from "jquery";
import autosize from "autosize";
import { Klass, u_, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwTextField";

/**
 * VuwTextareaField (extends VuwTextField)
 * @options
 * - {Boolean} required
 * - {Number} ltd
 * - {String} placeholder
 * - {Boolean} autosize
 * - {Boolean} isBlock
 */
vuwer.appendKlass("VuwTextareaField", {
	inpType: "textarea",
	inpClassList: ["inp"],
	
	_initialize: function _initialize(opt) {
		u_.isObject(opt) || (opt = {});
		return Klass("VuwTextareaField").parent._initialize.call(this, opt);
	},
	
	autosize: true,
	autosizeInit: function autosizeInit() {
		if( u_.isFunction(autosize) ) {
			if(this.$inp.length) {
				if( this.$inp.is(":visible") ) {
					autosize(this.$inp);
					this.$inp.addClass("autosize-target");
				}
			} else {
				csl.warn(this.getAddress() + " has no input element.");
			}
		} else {
			csl.warn(this.getAddress() + " ... autosize plugin isn't included.");
		}
		return this;
	},
	
	autosizeUpdate: function autosizeUpdate() {
		if(this.$inp.length) {
			if( this.$inp.hasClass("autosize-target") ) {
				autosize.update(this.$inp);
			} else {
				this.autosizeInit();
			}
		}
		return this;
	},
	
	getInpReady: function getInpReady($self) {
		// DOMツリーに登録される前のことも考慮して、$self.findで取得する
		this.$inp = $self.find("#" + ["inp", this.idStr].join("_"));
		if(this.$inp.length) {
			// ※IEでautosizeが動かなくなるため、inputイベントのモニター処理はしない
			this.$inp
			.on("change.setVal", function(e, isTrigger) {
				!isTrigger && $.data(this, "vuwField").setVal(this.value, true);
			});
			
			// **** attachPlugin ****
			// [autosize]
			if(this.autosize) {
				this.$inp.on("focus.autosizeInit", function() {
					var $this = $(this);
					if( !$this.hasClass("autosize-target") ) {
						$.data(this, "vuwField").autosizeInit();
					}
					$this.off(".autosizeInit");
				});
			}
			
			$.data(this.$inp.get(0), "vuwField", this);
			
			this.clearVal();
		}
		return this;
	},
	
	showPrompt: function showPrompt(valiKey) {
		Klass("VuwTextareaField").parent.showPrompt.call(this, valiKey);
		
		// inputイベントのモニター処理をしていないので、refreshは独自に実装する
		this.$self.on("input.refresh", function(e, isTrigger) {
			$(this).removeClass("is-error").attr("title", "").off(".refresh");
		});
		
		return this;
	},
	
	setVal: function setVal(value, antiTriggerChange) {
		Klass("VuwTextareaField").parent.setVal.call(this, value, antiTriggerChange);
		(!antiTriggerChange && this.autosize) && this.autosizeUpdate();
		return this;
	},
	
	_getCopiedInp: function _getCopiedInp(val) {
		var clones = [];
		
		(val === undefined) && ( val = this.getVal() );
		
		if( u_.isString(val) && val ) {
			val = u_.textareaParse(val, this.isBlock);
			clones.push( !!this.isBlock ? $("<div/>") : $("<p/>") );
			clones[0].addClass("replaced-inp").html( $.parseHTML(val) );
			clones[0].find("a").attr("target", "_blank");
		}
		
		return clones;
	},
	
	_renderField: function _renderField() {
		var attr = {
			name: this.paramKey,
			id: ["inp", this.idStr].join("_")
		};
		
		// set placeholder
		if( this.placeholder && u_.isString(this.placeholder) ) {
			attr.placeholder = this.placeholder;
		}
		
		return $("<fieldset/>").addClass("vuw-field field-txtarea").append(
			$("<textarea/>").addClass( this.inpClassList.join(" ") ).attr(attr)
		).attr({
			"id": ["field", this.idStr].join("_"),
			"data-name": this.paramKey
		});
	}
}, "VuwTextField");
